import React, { useRef } from 'react'
import { Pressable } from 'react-native'
import { DocumentPickerProps, DocumentPickerResult } from './DocumentPicker.types'
import styles from './DocumentPicker.styles'

export const DocumentPicker: React.FC<DocumentPickerProps> = ({
  onFilePicked,
  onError,
  onCancel,
  acceptedTypes = ['*/*'],
  multiple = false,
  children
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handlePress = () => {
    if (inputRef.current) {
      inputRef.current.click()
    }
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    
    if (!files || files.length === 0) {
      onCancel?.()
      return
    }

    try {
      Array.from(files).forEach((file) => {
        const reader = new FileReader()
        
        reader.onload = (e) => {
          const result = e.target?.result
          if (result) {
            const documentResult: DocumentPickerResult = {
              uri: result as string,
              name: file.name,
              type: file.type,
              size: file.size
            }
            onFilePicked(documentResult)
          }
        }
        
        reader.onerror = () => {
          onError?.(new Error(`Erreur lors de la lecture du fichier: ${file.name}`))
        }
        
        reader.readAsDataURL(file)
      })
    } catch (error) {
      onError?.(error as Error)
    }

    // Réinitialiser l'input pour permettre la sélection du même fichier
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={acceptedTypes.join(',')}
        multiple={multiple}
        onChange={handleFileChange}
        style={styles.hiddenInput as any}
      />
      <Pressable onPress={handlePress}>
        {children}
      </Pressable>
    </>
  )
}

export default DocumentPicker;